export const availabilityTime = [
  {
    id: 1,
    title: 'EST',
    icon: 'clock',
    desc: "09:00 AM - 05:00 PM"
  }
];
